module.exports = __webpack_public_path__ + "static/media/nophotoproduct.e390b3b8.jpg";